var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group',{attrs:{"validator":_vm.v,"label":_vm.label,"description":_vm.description,"use-label":_vm.useLabel,"use-horizontal":_vm.useHorizontal}},[_c('b-form-select',{staticClass:"form-control",attrs:{"options":_vm.options,"size":_vm.size},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }